import { getHttpClient } from "@root/httpClient";
import { getHttpClientV2 } from "@root/httpClientV2";
import {
  setGetDashboardDataDone,
  setGetWithdrawalConditionsDone,
  setHasTimeRedux,
  setPayrollFilterGlobal,
} from "@root/store/counter/appStatusSlice";
import { setTabNumber } from "@root/store/counter/changeTabSlice";
import { setExchangeCompleted } from "@root/store/counter/checkExchangeCompletedCashDSlice";
import { setDashboardData } from "@root/store/counter/dashboardDataSlice";
import {
  clearDeductionCashD,
  setDeductionsPage,
} from "@root/store/counter/deductionsCashDSlice";
import { setIsAuthenticated } from "@root/store/counter/loginSlice";
import {
  clearTransactionCashD,
  setTransactionsPage,
} from "@root/store/counter/transactionsCashDSlice";
import {
  setUser,
  setTermsAndConditionsAccepted,
  setWithdrawalConditions,
} from "@root/store/counter/userInfoSlice";
import {
  setBalance,
  setBankAccount,
  setTotalWithdrawalsLast6Months,
} from "@root/store/counter/financialInfoSlice";
import { getWhiteLabellingData } from "@root/store/counter/whiteLabellingSlice";
import { MD5 } from "crypto-js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
//GOOGLE ANALYTICS import
import ReactGA from "react-ga4";

export interface UserBaseInfor {
  staff_id: string;
  company_id: string;
  countryData: any;
}

let userBaseInfor: UserBaseInfor = {
  staff_id: "",
  company_id: "",
  countryData: {
    countryCurrencyCode: "",
    countryName: "",
    currencySymbol: "",
  },

};

export default function useLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getCodeLogin = async (email: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<any>("/api/user/getotp", {
        email,
      });
      return data;
    } catch (error: any) {
      if (error.response) {
        return {
          code: error?.response?.data?.result?.code,
          message: error?.response?.data?.result?.message,
          data: error?.response?.data?.result?.data,
        };
      } else {
        return {
          success: false,
          message: "Invalid code",
        };
      }
    }
  };

  const requestEmployerInvite = async (email: string, firstName: string, lastName: string, mobile: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<any>("/api/user/requestEmployerInvite", {
        email,
        firstName,
        lastName,
        mobile
      });
      return data;
    } catch (error: any) {
      if (error.response) {
        return {
          code: error?.response?.data?.result?.code || error?.response?.data?.code || 400,
          message: error?.response?.data?.result?.message || error?.response?.data?.message || "Failed to submit request",
        };
      } else {
        return {
          success: false,
          message: "Connection failed",
        };
      }
    }
  };

  const login = async (
    email: string,
    isLoginOTP: boolean,
    otpCode: string,
    password: string,
    loginType: string,
    finalDeviceId: number
  ) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/loginbyotporpassword", {
        email: email,
        password: isLoginOTP ? otpCode : password,
        login_type: loginType,
        time_offset: "25200000",
        device_id: finalDeviceId,
      });
      return data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message
      if (errorMessage === "Not found 'Code' in system" || errorMessage === "Your Code has expired") {
        return {
          success: false,
          message: errorMessage,
        };
      }

      return {
        success: false,
        message: errorMessage || "Login failed!",
      };
    }
  };

  const verifyOTP = async (email: string, OTP: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/verify-otp", {
        email: email,
        OTP: OTP,
      });
      let _data: any = data;
      let userToken = _data?.result?.data?.userData?.token;
      localStorage.setItem("token", userToken);
      localStorage.setItem("userId", _data?.result?.data?.userData?._id);
      userBaseInfor.staff_id = _data?.result?.data?.staffData?._id;
      userBaseInfor.company_id = _data?.result?.data?.companyData?._id;
      userBaseInfor.countryData = _data?.result?.data?.countryData;
      localStorage.setItem("countryData", JSON.stringify(_data?.result?.data?.countryData));
      localStorage.setItem("userInfor", JSON.stringify(userBaseInfor));
      dispatch(setTermsAndConditionsAccepted(_data?.result?.data?.userData?.isTermsAndConditionsAccepted));
      return data;
    } catch (error: any) {
      if (error.response) {
        return {
          code: error?.response?.data?.code,
          message: error?.response?.data?.message,
        };
      }
    }
  };

  const verifyOTPUnregistered = async (email: string, OTP: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/verify-otp-unregistered", {
        email: email,
        OTP: OTP,
      });
      let _data: any = data;
      let userToken = _data?.result?.data?.token;
      sessionStorage.setItem("temptoken", userToken);
      return data;
    } catch (error: any) {
      if (error.response) {
        return {
          code: error?.response?.data?.code,
          message: error?.response?.data?.message,
        };
      }
    }
  };

  const getUserProfile = async (userId: string) => {
    const httpClient = getHttpClientV2();
    try {
      const { data } = await httpClient.get<{
        result: {
          type: string;
          statusCode: number | string;
          code: number;
          data: any;
        };
      }>(`/api/user/get-user-profile`, {
        params: {
          userId,
        },
      });
      let _data: any = data;
      userBaseInfor.staff_id = _data?.result?.data?.staffs?._id;
      userBaseInfor.company_id = _data?.result?.data?.companies?._id;
      userBaseInfor.countryData = _data?.result?.data?.company_country;
      localStorage.setItem("userInfor", JSON.stringify(userBaseInfor));
      dispatch(
        getWhiteLabellingData({
          logoUrl: _data?.result?.data?.companies?.brand?.logoUrl,
          primaryColor: _data?.result?.data?.companies?.brand?.primaryColor,
          secondaryColor: _data?.result?.data?.companies?.brand?.secondaryColor,
          custom: _data?.result?.data?.companies?.brand?.custom,
        })
      );
      dispatch(setTermsAndConditionsAccepted(_data?.result?.data?.isTermsAndConditionsAccepted));
      return data;
    } catch (error: any) {
      console.log(error.type);
      return {
        type: error.result,
        message: "Get user profile failed!",
      };
    }
  };

  const getToken = async (device_id: string, refresh_token: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/get-token", {
        device_id,
        refresh_token,
      });
      return data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message
      if (errorMessage === "Not found 'Code' in system" || errorMessage === "Your Code has expired") {
        return {
          success: false,
          message: errorMessage,
        };
      }
      return {
        success: false,
        message: "Login failed!",
      };
    }
  };

  const getForgotCodePassword = async (email: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.get<{
        result: {
          success: boolean;
          response: any;
        };
      }>(`/api/user/get-code-forgot-password`, {
        params: {
          email,
        },
      });
      return data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      if (errorMessage === "Not found 'Code' in system" || errorMessage === "Your Code has expired") {
        return {
          success: false,
          message: errorMessage,
        };
      }
      return {
        success: false,
        message: "Login failed!",
      };
    }
  };

  const enterCodeForgotPassword = async (email: string, code: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/enter-code-forgot-password", {
        email,
        code,
      });
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message === "Your Code was expired") {
        return {
          success: false,
          message: error?.response?.data?.message,
        };
      } else if (
        error?.response?.data?.message === 'Not found "Code" in system'
      ) {
        return {
          success: false,
          message: "Code is invalid!",
        };
      } else {
        return {
          success: false,
          message: "Verify forgot password code failed!",
        };
      }
    }
  };

  const createNewPassword = async (
    new_password: string,
    email: string,
    code: string
  ) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/create-new-password", {
        new_password: MD5(new_password).toString(),
        email,
        code,
      });
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message === "Your Code was expired") {
        return {
          success: false,
          message: error?.response?.data?.message,
        };
      } else if (
        error?.response?.data?.message === 'Not found "Code" in system'
      ) {
        return {
          success: false,
          message: "Code is invalid!",
        };
      } else {
        return {
          success: false,
          message: "Verify forgot password code failed!",
        };
      }
    }
  };

  const registerEmployee = async (activationCode: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>(`/api/user/register-employee?activationCode=${activationCode}`);
      dispatch(setTermsAndConditionsAccepted(data?.result?.response?.isTermsAndConditionsAccepted));
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message === "Your Code was expired") {
        return {
          success: false,
          message: error?.response?.data?.message,
        };
      } else if (
        error?.response?.data?.message === 'Not found "Code" in system'
      ) {
        return {
          success: false,
          message: "Code is invalid!",
        };
      } else {
        return {
          success: false,
          message: "Verify forgot password code failed!",
        };
      }
    }
  };

  const inviteUser = async (activationCode: string) => {
    const httpClient = getHttpClient();
    try {
      const { data } = await httpClient.get<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/user-invitation", {
        params: { activationCode },
      });
      return data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.message === "Your Code was expired") {
        return {
          success: false,
          message: error?.response?.data?.message,
        };
      } else if (
        error?.response?.data?.message === 'Not found "Code" in system'
      ) {
        return {
          success: false,
          message: "Code is invalid!",
        };
      } else {
        return {
          success: false,
          message: "Verify forgot password code failed!",
        };
      }
    }
  };

  const acceptTNC = async (token: string) => {
    const httpClient = getHttpClientV2();
    try {
      const { data } = await httpClient.post<{
        result: {
          success: boolean;
          response: any;
        };
      }>("/api/user/accept-tnc-unregistered", {
        token
      });
      return data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.message) {
        return {
          success: false,
          message: error?.response?.data?.message,
        };
      } else {
        return {
          success: false,
          message: "Code is invalid!",
        };
      }
    }
  };

  const handleLogout = () => {
    ReactGA.event({
      category: "User Interaction",
      action: "Clicked “Yes” on the logout pop up",
      label: "Button Clicked",
    });

    // 1. Clear all session storage
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userInfor");
    localStorage.removeItem("userId");
    localStorage.removeItem("countryData");
    sessionStorage.removeItem("temptoken");

    // 2. Clear Redux Navigation State
    dispatch(setTabNumber(0));
    dispatch(setIsAuthenticated(false));
    dispatch(setPayrollFilterGlobal("current"));

    // 3. Clear Redux Data Lists (Transactions & Deductions)
    dispatch(clearTransactionCashD([]));
    dispatch(clearDeductionCashD([]));
    dispatch(setTransactionsPage(0));
    dispatch(setDeductionsPage(0));

    // 4. Reset User Info & Conditions
    dispatch(setUser(null));
    dispatch(setTermsAndConditionsAccepted(null));
    dispatch(setWithdrawalConditions(null));

    // 5. Reset Financial & Dashboard State
    dispatch(setDashboardData(null));
    dispatch(setBalance(0));
    dispatch(setTotalWithdrawalsLast6Months(0));
    dispatch(setBankAccount(null));
    dispatch(setGetDashboardDataDone(false));
    dispatch(setGetWithdrawalConditionsDone(false));
    dispatch(setHasTimeRedux(false));
    dispatch(setExchangeCompleted(false));

    // 6. Reset White Labelling to default
    dispatch(getWhiteLabellingData({
      logoUrl: "",
      primaryColor: "",
      secondaryColor: "",
      custom: false
    }));

    // 7. Navigate back to login
    navigate("/login");
  };

  return {
    getCodeLogin,
    requestEmployerInvite,
    login,
    getToken,
    getUserProfile,
    getForgotCodePassword,
    enterCodeForgotPassword,
    createNewPassword,
    registerEmployee,
    inviteUser,
    handleLogout,
    verifyOTP,
    verifyOTPUnregistered,
    acceptTNC
  };
}
